/** Poll timing aligned with backend social-post publish guide. */
export const SOCIAL_POST_POLL_INTERVAL_MS = 4000;
export const SOCIAL_POST_POLL_MAX_MS = 300_000;

/** Client timeout on POST /publish — abandon waiting before gateway 504; server keeps running. */
export const SOCIAL_POST_PUBLISH_REQUEST_TIMEOUT_SEC = 15;

/** Delay before first GET poll after fire-and-forget publish kick-off. */
export const SOCIAL_POST_PUBLISH_POLL_START_DELAY_MS = 2000;

/** Extra wait when post is still draft before declaring publish never started. */
export const SOCIAL_POST_PUBLISH_DRAFT_GRACE_MS = 4000;

export function getSocialPostHttpStatus(error: unknown): number | undefined {
    const e = error as { status?: number; data?: { status?: number } };
    return e?.status ?? e?.data?.status;
}

export function getSocialPostErrorMessage(error: unknown, fallback: string): string {
    const e = error as { data?: { message?: string }; message?: string };
    return e?.data?.message ?? e?.message ?? fallback;
}

/** Gateway timeout or client abort — publish may still succeed server-side. */
export function isSocialPostPublishTimeoutError(error: unknown): boolean {
    const e = error as { code?: string; status?: number };
    if (e?.code === 'ECONNABORTED') return true;
    const status = getSocialPostHttpStatus(error);
    return status === 504 || status === 502;
}

/** 400 when server already accepted a publish — poll instead of retrying POST. */
export function isSocialPostPublishAlreadyInProgressError(error: unknown): boolean {
    if (getSocialPostHttpStatus(error) !== 400) return false;
    const msg = getSocialPostErrorMessage(error, '').toLowerCase();
    return msg.includes('already being published') || msg.includes('already been published');
}

export function shouldPollAfterPublishError(error: unknown): boolean {
    return isSocialPostPublishTimeoutError(error) || isSocialPostPublishAlreadyInProgressError(error);
}

const publishingPostIds = new Set<string>();

export function markSocialPostPublishInFlight(postId: string): boolean {
    if (publishingPostIds.has(postId)) return false;
    publishingPostIds.add(postId);
    return true;
}

export function clearSocialPostPublishInFlight(postId: string): void {
    publishingPostIds.delete(postId);
}
